import { DataUtil } from "../util/data.util";
import { TipoAto } from "./tipo-ato.model";

export class BuscaAto {
    
    idAto!: number | undefined;
    listaIdsTipoAto!: number[] | undefined;
    numeroAto!: string | undefined;
    listaIdsOrgao!: number[] | undefined;
    listaSiglasOrgao!: string[] | undefined;
    dataPublicacaoStr!: string | undefined;
    anoAto!: string | undefined;
    
    dataAtoInicial!: Date | undefined;
    dataAtoFinal!: Date | undefined;
    dataAtoInicialStr!: string | undefined;
    dataAtoFinalStr!: string | undefined;

    dataPublicacaoInicial!: Date | undefined;
    dataPublicacaoFinal!: Date | undefined;
    dataPublicacaoInicialStr!: string | undefined;
    dataPublicacaoFinalStr!: string | undefined;

    dataInicioVigenciaInicial!: Date | undefined;
    dataInicioVigenciaFinal!: Date | undefined;
    dataInicioVigenciaInicialStr!: string | undefined;
    dataInicioVigenciaFinalStr!: string | undefined;

    dataFimVigenciaInicial!: Date | undefined;
    dataFimVigenciaFinal!: Date | undefined;
    dataFimVigenciaInicialStr!: string | undefined;
    dataFimVigenciaFinalStr!: string | undefined;

    situacao = 0;                   // 0 - Indiferente
    tipoVisao = 0;                  // 0 - Indiferente
    exibirVisoes = '1111';
    exibicaoInternet = 0;           // 0 - Indiferente
    exibicaoSijut1 = 0;             // 0 - Indiferente

    exibirEmenta = false;
    observacaoAto!: string | undefined;
    listaIdsAssunto!: number[] | undefined;
    listaIdsAreaResponsavel!: number[] | undefined;
    idLocalPublicacao = 0;          // 0 - Indiferente
    secao!: string | undefined;
    numeroPagina!: number | undefined;
    textoLivre!: string | undefined;

    apenasComTodosOrgaos = false;

    tipoAto!: TipoAto | undefined;

    converterDatasStr(): void {

        if (this.dataAtoInicial) {
            this.dataAtoInicialStr = DataUtil.getDataStr(this.dataAtoInicial);
        }
        if (this.dataAtoFinal) {
            this.dataAtoFinalStr = DataUtil.getDataStr(this.dataAtoFinal);
        }

        if (this.dataPublicacaoInicial) {
            this.dataPublicacaoInicialStr = DataUtil.getDataStr(this.dataPublicacaoInicial);
        }
        if (this.dataPublicacaoFinal) {
            this.dataPublicacaoFinalStr = DataUtil.getDataStr(this.dataPublicacaoFinal);
        }

        if (this.dataInicioVigenciaInicial) {
            this.dataInicioVigenciaInicialStr = DataUtil.getDataStr(this.dataInicioVigenciaInicial);
        }
        if (this.dataInicioVigenciaFinal) {
            this.dataInicioVigenciaFinalStr = DataUtil.getDataStr(this.dataInicioVigenciaFinal);
        }

        if (this.dataFimVigenciaInicial) {
            this.dataFimVigenciaInicialStr = DataUtil.getDataStr(this.dataFimVigenciaInicial);
        }
        if (this.dataFimVigenciaFinal) {
            this.dataFimVigenciaFinalStr = DataUtil.getDataStr(this.dataFimVigenciaFinal);
        }
    }
}
